import styled from 'styled-components'

import { CheckMark } from '@/components/shared/icons/CheckMark'

const StyledCheckMark = styled.div`
  margin-right: 12px;
  padding-top: 4px;
`

const StyledListItemWithIcons = styled.li`
  display: flex;
  align-items: flex-start;
  padding-bottom: 32px;
  margin-top: 32px;
  font-size: ${(p) => p.theme.v2.typography.body.xl.fontSize};
  line-height: ${(p) => p.theme.v2.typography.body.xl.lineHeight};
  font-family: ${(p) => p.theme.v2.font.nantes};
  color: #2d3246;
  border-bottom: 1px solid #e2e2e2;

  &:last-of-type {
    margin-bottom: 0;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.tablet}) {
    font-size: ${(p) => p.theme.v2.typography.body.s.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.s.lineHeight};
    padding-bottom: 16px;
    margin-top: 16px;
    align-items: center;
  }

  @media screen and (max-width: ${(p) => p.theme.breakpoints.mobile}) {
    font-size: ${(p) => p.theme.v2.typography.body.xl.fontSize};
    line-height: ${(p) => p.theme.v2.typography.body.xl.lineHeight};
    padding-bottom: 32px;
    margin-top: 32px;
  }
`

type GitShotListItemWithIconProps = {
  text: string
}

export const GutShotListItemWithIcon: React.FC<GitShotListItemWithIconProps> = ({ text }) => {
  return (
    <StyledListItemWithIcons>
      <StyledCheckMark>
        <CheckMark colour="#FFD100" />
      </StyledCheckMark>
      <span>{text}</span>
    </StyledListItemWithIcons>
  )
}
